import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppNavbar from "./components/AppNavbar.vue";
import AppFooter from "./components/AppFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let first = true;
function focusHeading() {
  // Not on first load: the visitor has not navigated yet.
  if (first) {
    first = false;
    return;
  }
  const h1 = document.querySelector("main h1") as HTMLElement | null;
  if (!h1) return;
  h1.setAttribute("tabindex", "-1");
  h1.focus({ preventScroll: true });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppNavbar),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component, route }) => [
          _createVNode(_Transition, {
            name: "route",
            mode: "out-in",
            onAfterEnter: focusHeading
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path
              }))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createVNode(AppFooter)
  ], 64))
}
}

})